// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium admin modals are more gray instead of white on black */
.taModal.modal .modal-body input[type='text'],
.taModal.modal .modal-body textarea,
.taModal.modal .modal-body md-datepicker-input {
  color: black;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
}
/* color the default text in the modal input boxes */
.taModal.modal .modal-body input[type='text']::-webkit-input-placeholder,
.taModal.modal .modal-body textarea::-webkit-input-placeholder,
.taModal.modal .modal-body .md-datepicker-input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: gray;
}
.taModal.modal .modal-body input[type='text']:-moz-placeholder,
.taModal.modal .modal-body textarea:-moz-placeholder,
.taModal.modal .modal-body .md-datepicker-input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: gray;
  opacity: 1;
}
.taModal.modal .modal-body input[type='text']::-moz-placeholder,
.taModal.modal .modal-body textarea::-moz-placeholder,
.taModal.modal .modal-body .md-datepicker-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: gray;
  opacity: 1;
}
.taModal.modal .modal-body input[type='text']:-ms-input-placeholder,
.taModal.modal .modal-body textarea:-ms-input-placeholder,
.taModal.modal .modal-body .md-datepicker-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: gray;
}

/* Form groups are packed tighter together on preimum admin modals */
.taModal.modal .form-group {
  margin-bottom: 10px;
}

.taModal.modal .form-control {
  height: 30px;
}

/* sub Title right below big bold title. allows for status */
.taModal.modal .subTitle {
  font-size: 14px;
}

/* Make down arrow fit in a smaller select container */
.taModal.modal .selectContainer .downArrow {
  height: 30px;
  margin-top: 1px;
  border-left: 1px solid #c5c5c5;
}
.taModal.modal .selectContainer .downArrow img {
  margin-top: 10px;
}

.ta-domain-switcher {
  margin: 5px 0;
}
/*
.taModal.modal .md-datepicker-input {
    background-color: white;
    border: 1px solid rgba(0,0,0, .2);
    border-radius: 2px;
}
.taModal.modal .md-datepicker-input-container {
    border-bottom-style: initial;
}
*/
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/premiumAdmin/modals.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;AACA,oDAAoD;AACpD;;;EAGE,wBAAwB;EACxB,WAAW;AACb;AACA;;;EAGE,4BAA4B;EAC5B,WAAW;EACX,UAAU;AACZ;AACA;;;EAGE,wBAAwB;EACxB,WAAW;EACX,UAAU;AACZ;AACA;;;EAGE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;;;;;;;;;CASC","sourcesContent":["/* Premium admin modals are more gray instead of white on black */\n.taModal.modal .modal-body input[type='text'],\n.taModal.modal .modal-body textarea,\n.taModal.modal .modal-body md-datepicker-input {\n  color: black;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  width: 100%;\n}\n/* color the default text in the modal input boxes */\n.taModal.modal .modal-body input[type='text']::-webkit-input-placeholder,\n.taModal.modal .modal-body textarea::-webkit-input-placeholder,\n.taModal.modal .modal-body .md-datepicker-input::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: gray;\n}\n.taModal.modal .modal-body input[type='text']:-moz-placeholder,\n.taModal.modal .modal-body textarea:-moz-placeholder,\n.taModal.modal .modal-body .md-datepicker-input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: gray;\n  opacity: 1;\n}\n.taModal.modal .modal-body input[type='text']::-moz-placeholder,\n.taModal.modal .modal-body textarea::-moz-placeholder,\n.taModal.modal .modal-body .md-datepicker-input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: gray;\n  opacity: 1;\n}\n.taModal.modal .modal-body input[type='text']:-ms-input-placeholder,\n.taModal.modal .modal-body textarea:-ms-input-placeholder,\n.taModal.modal .modal-body .md-datepicker-input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: gray;\n}\n\n/* Form groups are packed tighter together on preimum admin modals */\n.taModal.modal .form-group {\n  margin-bottom: 10px;\n}\n\n.taModal.modal .form-control {\n  height: 30px;\n}\n\n/* sub Title right below big bold title. allows for status */\n.taModal.modal .subTitle {\n  font-size: 14px;\n}\n\n/* Make down arrow fit in a smaller select container */\n.taModal.modal .selectContainer .downArrow {\n  height: 30px;\n  margin-top: 1px;\n  border-left: 1px solid #c5c5c5;\n}\n.taModal.modal .selectContainer .downArrow img {\n  margin-top: 10px;\n}\n\n.ta-domain-switcher {\n  margin: 5px 0;\n}\n/*\n.taModal.modal .md-datepicker-input {\n    background-color: white;\n    border: 1px solid rgba(0,0,0, .2);\n    border-radius: 2px;\n}\n.taModal.modal .md-datepicker-input-container {\n    border-bottom-style: initial;\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
